<template>
    <v-container fluid>
        <v-row no-gutters>
            <v-col v-if="agent" cols="2" align="start" style="align-content: center;">
                <div>
                    <v-img
                        :src="this.$store.getters.getClientImage"
                        class="bot-image ml-auto"
                        :aspect-ratio="16/9"
                        positison="bottom"
                        contain
                    />
                </div>
            </v-col>
            <v-col align="start">
                <div :class="agent ? 'grey--text text--darken-4 grey lighten-3' : ''" :style="`float: ${agent ? 'left' : 'right'}; background-color: ${mainColor}`" class="white--text rounded-xl px-3 py-3  bubble-text"> {{ reply.message.text }}</div>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    export default {
        props: {
            agent: {
                type: Boolean,
                default: false
            },
            reply: {
                type: Object,
            },
            mainColor: {
                type: String,
                default: null
            }
        },
        data: () => ({
            data:
            {
                "message":
                {
                    "text":"Hello, world!"
                }
            }
        }),
        methods: {
        }
    }
</script>

<style scoped src="../../../node_modules/vuetify/dist/vuetify.min.css">
</style>

<style scoped src="@mdi/font/css/materialdesignicons.css">
</style>

<style>
.bot-image {
    border-radius: 50%;
}
</style>